
export default function AboutSection() {
  return (
    <section id="sobre-nosotros" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Asociación Cultural SAMARITA</h1>
          <div className="flex justify-center mb-8">
            <img
              src="/assets/img/custom-images/logo-samaritas.png"
              alt="Asociación Cultural SAMARITA"
              className="h-32 w-auto"
            />
          </div>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed">
            La Asociación Cultural SAMARITA promueve las tradiciones, la cultura y las fiestas de la localidad de Alcoy,
            situada en la provincia de Alicante (España). Para conocer más sobre nosotros, visita nuestra{' '}
            <a
              href="https://www.acsamarita.com/"
              className="text-red-600 hover:text-red-700 font-medium"
              target="_blank"
              rel="noopener noreferrer"
            >
              página web
            </a>.
          </p>
        </div>
      </div>
    </section>
  );
}
